import { ResetPasswordScreen } from '@/screens/auth/reset-password-screen';
export default ResetPasswordScreen;
